var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.5C8.433 14.5 10 11.8137 10 8.5C10 5.18629 8.433 2.5 6.5 2.5C4.567 2.5 3 5.18629 3 8.5C3 11.8137 4.567 14.5 6.5 14.5Z",
    stroke: "#B6B6B6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.5H9.5C11.4312 2.5 13 5.1875 13 8.5C13 11.8125 11.4312 14.5 9.5 14.5H6.5",
    stroke: "#B6B6B6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10645 4.5H12.1064",
    stroke: "#B6B6B6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5H13",
    stroke: "#B6B6B6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10645 12.5H12.1064",
    stroke: "#B6B6B6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.da5614849e56a7317a18601bb45b5e8a.svg";
export { ForwardRef as ReactComponent };